import * as St from './FilterOptions.styles';

import InputOption from '~molecules/InputOption';

export type Option = { label: string; qty: number };

export type FilterOptionsData = {
  options: Option[];
};

export type SelectedOptions = string[];

export type FilterOptionsProps = {
  title: string;
  data: FilterOptionsData;
  selectedOptions?: SelectedOptions;
  onChange: (selected: SelectedOptions) => void;
};

const FilterOptions = ({
  title,
  data: { options },
  onChange,
  selectedOptions = [],
}: FilterOptionsProps) => {
  const handleChange = (optId: string) => () =>
    onChange(
      selectedOptions.includes(optId)
        ? selectedOptions.filter((op) => op !== optId)
        : [...selectedOptions, optId]
    );

  return (
    <St.Container>
      <St.Legend>{title}</St.Legend>

      {options.map(({ label, qty }) => (
        <InputOption
          type="checkbox"
          key={label}
          value={label}
          isChecked={qty > 0 && selectedOptions.includes(label)}
          isDisabled={qty < 1}
          onChange={handleChange(label)}
          label={
            <>
              <St.OptionLabel>{label}</St.OptionLabel>
              <St.Qty> {`(${qty})`}</St.Qty>
            </>
          }
        />
      ))}
    </St.Container>
  );
};

export default FilterOptions;
